import { useEffect, useState } from "preact/hooks";
import type { FriendDaily } from "../net/api.js";
import { api } from "../net/api.js";

/**
 * How friends did at today's daily (P4-TANK-03 step 3), for signed-in people: their best of the
 * day, best first. Friends who appear offline aren't shown (the api leaves them out). `version`
 * changes after a new best of mine is saved, to read the list again. Nothing for a guest.
 */
export function FriendsDaily({
  gameId,
  day,
  version = 0,
}: {
  gameId: string;
  day: string;
  version?: number;
}) {
  const [friends, setFriends] = useState<FriendDaily[] | null>(null);
  useEffect(() => {
    let live = true;
    api.dailyBoard(gameId, day).then(
      (b) => {
        if (live) setFriends(b.friends);
      },
      () => {
        // A guest (401) or offline: no list.
      },
    );
    return () => {
      live = false;
    };
  }, [gameId, day, version]);
  if (friends === null) return null;
  if (friends.length === 0)
    return <p class="hint">None of your friends has played today's daily yet.</p>;
  return (
    <div class="friends-daily">
      <h3>Friends today</h3>
      <ol>
        {friends.map((f) => (
          <li key={f.id}>
            <span class="name">{f.name}</span>{" "}
            <span class="dim">
              {f.won ? "won" : "lost"}
              {f.stars > 0 ? `, ${"★".repeat(f.stars)}` : ""}
              {f.score > 0 ? `, ${String(f.score)}` : ""}
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
}
